export const SHARE_REMINDERS = [
  {
    arabic: "بَلِّغْ مَآ أُنزِلَ إِلَيْكَ مِن رَّبِّكَ",
    english: "Announce that which has been revealed to you from your Lord!",
    source: "Surat Al-Ma’idah 5:67",
  },
  {
    arabic: "وَذَكِّرْ فَإِنَّ ٱلذِّكْرَىٰ تَنفَعُ ٱلْمُؤْمِنِينَ",
    english: "And remind, for indeed, the reminder benefits the believers.",
    source: "Surat Adh-Dhariyat 51:55",
  },
  {
    english:
      "The Prophet (ﷺ) said, “He who calls others to follow the Right Guidance will have a reward equal to the reward of those who follow him.”",
    source: "Muslim",
  },
  {
    english:
      "The Prophet (ﷺ) said, “Convey (my teachings) to the people even if it were a single sentence.”",
    source: "Bukhari",
  },
  {
    english:
      "The Prophet (ﷺ) said, “By Allah, if a single person is guided by Allah through you, it will be better for you than a whole lot of red camels.”",
    source: "Al-Bukhari and Muslim",
  },
  {
    english:
      "The Prophet (ﷺ) said, “The most beloved people to Allah are those who are most beneficial to people.”",
    source: "al-Mu’jam al-Awsat",
  },
  {
    english:
      "The Prophet (ﷺ) said, “May Allah brighten the face of a person who hears a hadith from us and he memorizes it until he can convey it to others.”",
    source: "Sunan Abi Dawud",
  },
];

export function reminderForJob(requestId) {
  const index = Math.abs(Number(requestId) || 0) % SHARE_REMINDERS.length;
  return SHARE_REMINDERS[index];
}

export function pickRandomShareReminder(exclude) {
  const pool =
    exclude && SHARE_REMINDERS.length > 1
      ? SHARE_REMINDERS.filter((item) => item !== exclude)
      : SHARE_REMINDERS;
  return pool[Math.floor(Math.random() * pool.length)];
}

export const SHARE_BUTTON_LABELS = [
  "Share",
  "Share for Khair",
  "Share for Reward",
  "Remind Others",
  "Benefit Others",
  "Remind to Benefit",
  "Convey",
];

export const SHARE_BUTTON_LABEL_SIZER = SHARE_BUTTON_LABELS.reduce(
  (longest, label) => (label.length > longest.length ? label : longest),
  ""
);

export function pickRandomShareButtonLabel(exclude) {
  const pool =
    exclude && SHARE_BUTTON_LABELS.length > 1
      ? SHARE_BUTTON_LABELS.filter((item) => item !== exclude)
      : SHARE_BUTTON_LABELS;
  return pool[Math.floor(Math.random() * pool.length)];
}
